export enum IhmsActionItems {
  Assigned = 1,
  SendBack = 2,
}
